import { request } from "../libs";

function addUser(user) {
	return request(
		"/server/users",
		{
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(user)
		}
	)
		.then(res => res.json());
}

export default addUser;



// WEBPACK FOOTER //
// ./src/api/add-user.js